import React from 'react';
import Sparkline from '../Sparkline/Sparkline';
import './KPICard.scss';

const KPICard = ({ 
    title, 
    value, 
    trend, 
    trendLabel, 
    trendData,
    absoluteChange,
    icon, 
    color = '#FF3232',
    loading = false,
    subtitle,
    onClick,
    showInfoIcon = true,
    formatAbsoluteChange
}) => {
    const isPositive = trend >= 0;
    const trendColor = isPositive ? '#4caf50' : '#f44336';
    const trendSymbol = isPositive ? '+' : '';

    return (
        <div 
            className={`kpi-card ${onClick ? 'clickable' : ''}`}
            onClick={onClick}
            style={{ '--kpi-color': color }}
        >
            <div className="kpi-header">
                <div className="kpi-title-wrapper">
                    <h3 className="kpi-title">{title}</h3>
                    {showInfoIcon && !loading && (
                        <div className="kpi-info-icon" title={subtitle || title}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                <path d="M7 4.5V3.5M7 10.5V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </div>
                    )}
                </div>
                {icon && (
                    <div className="kpi-icon" style={{ backgroundColor: `${color}15` }}>
                        {icon}
                    </div>
                )}
            </div>
            
            <div className="kpi-content">
                {loading ? (
                    <div className="kpi-loading">
                        <div className="loading-skeleton" style={{ width: '80px', height: '32px' }}></div>
                    </div>
                ) : (
                    <div className="kpi-value">{value}</div>
                )}
                
                {subtitle && !loading && (
                    <div className="kpi-subtitle">{subtitle}</div>
                )}
                
                {trendData && trendData.length > 0 && !loading && (
                    <div className="kpi-sparkline">
                        <Sparkline data={trendData} color={trendColor} height={40} />
                    </div>
                )}
                
                {trend !== undefined && trend !== null && !loading && (
                    <div className="kpi-trend" style={{ color: trendColor }}>
                        <span className="trend-value">
                            {absoluteChange !== undefined && absoluteChange !== null && typeof absoluteChange === 'number' ? (
                                <>
                                    {trendSymbol}{formatAbsoluteChange && typeof formatAbsoluteChange === 'function' ? formatAbsoluteChange(Math.abs(absoluteChange)) : absoluteChange} ({trendSymbol}{typeof trend === 'number' ? trend.toFixed(1) : trend}%)
                                </>
                            ) : (
                                <>
                                    {trendSymbol}{typeof trend === 'number' ? trend.toFixed(1) : trend}%
                                </>
                            )}
                        </span>
                        {trendLabel && (
                            <span className="trend-label"> {trendLabel}</span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default KPICard;





